import React from 'react';
import PropTypes from 'prop-types';
import {SubmitButton} from '../SubmitButton';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities';

const UNLIIMTED_ATTEMPTS = {
  VALUE: -10,
  TEXT: 'Unlimited',
};

/**
 * Footer component for Question
 */
export function QuestionFooter(props) {
  const renderTotalCount = () => {
    if (props.totalAttempts === UNLIIMTED_ATTEMPTS.VALUE) {
      return UNLIIMTED_ATTEMPTS.TEXT;
    } else {
      return props.totalAttempts;
    }
  };

  return (
    <div className={props.className}>
      <div className={`${props.className}-left`}>
        Attempts Left: {renderTotalCount()}
      </div>
      <div className={`${props.className}-right`}>
        {props.children}
        <SubmitButton
          componentID={props.componentID}
          componentType={props.componentType}
          disabled={props.submitDisabled}
          submitAnswer={props.submitAnswer}
        />
      </div>
    </div>
  );
}

QuestionFooter.propTypes = {
  /**
   * This prop can be used to display some element between submit button and total Attempts count
   */
  children: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.element]),
  /**
   * className to be set for the footer wrapper
   */
  className: PropTypes.string.isRequired,
  /**
   * Boolean value to specify if question operations complete
   */
  complete: PropTypes.bool.isRequired,
  /**
   * Unique Id for the question component
   */
  componentID: PropTypes.number.isRequired,
  /**
   * To specify the component Type
   */
  componentType: PropTypes.oneOf([
    COMPONENT_TYPE.CSCQ,
    COMPONENT_TYPE.MSCQ,
    COMPONENT_TYPE.DDQ,
    COMPONENT_TYPE.DNDQ_COLOR,
    COMPONENT_TYPE.GROUPED_DNDQ,
    COMPONENT_TYPE.CSCQ_COLOR,
    COMPONENT_TYPE.QUESTION_TABLE,
  ]).isRequired,
  /**
   * Total number of attempts possible for the question
   */
  totalAttempts: PropTypes.number.isRequired,
  /**
   * Function to handle the submit action
   */
  submitAnswer: PropTypes.func.isRequired,
  /**
   * Boolean value to disable/enable submit button
   */
  submitDisabled: PropTypes.bool.isRequired,
};

QuestionFooter.defaultProps = {
  children: null,
};
